import * as React from "react";
const SvgPrint20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M4 8v2h2V8H4Zm3.5 6.75h5v-1h-5v1Zm5 1.5h-5v-1h5v1Z"
    }),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M16 5h3v12.333h-3V19H4v-1.667H1V5h3V1h12v4ZM6 3h8v2H6V3Zm11 12.333h-1V11H4v4.333H3V7h14v8.333ZM6 13h8v4H6v-4Z",
      clipRule: "evenodd"
    })
  );
export default SvgPrint20Px;
